import { render } from "./TableHeader.vue?vue&type=template&id=206c871e&ts=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__